// extracted by mini-css-extract-plugin
export default {"container":"S2Q_Li","box":"lZm73x","title":"G6CZ_8","subtitle":"KYOjGv","button":"KfA2EQ"};